module.exports = __webpack_public_path__ + "img/5.5d278938.png";